<template>
  <div>
    <appHeader></appHeader>
    <appModal></appModal>
    <div class="container-fluid transaction-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 marginForHeader">
            <h4>Funding Dashboard</h4>
            <div :style="{ 'font-weight': 600 }">
              <p>Welcome to the Funding Module!</p>
              <p>Prefunding is a crucial aspect of financial management, and our new module aims to simplify and enhance this process for you. By utilizing our Funding Dashboard, you can enjoy a seamless experience, save time, and ensure your funding activities are in sync with your business goals.</p>
              <p>Getting started with our Funding Dashboard is easy! Just log in to your account, head to the Funding Dashboard section, add a default payment method, and provide your billing details.</p>
              <p>If you have any questions or require assistance, our dedicated support team is here to help. Feel free to reach out to <a href="mailto:clientcare@divvyengagement.com">clientcare@divvyengagement.com</a>.</p>
            </div>
            <div>
              <p :style="{ 'color': 'rgba(0, 0, 0, 0.85)', 'font-size': '18px' }"><b>Please keep in mind the following:</b></p>
              <ul :style="{ 'font-weight': 600 }">
                <li>Payments made via ACH take approximately 4-5 business days to process.</li>
                <li>Funds are withdrawn from your balance when end users redeem points by placing orders, not when points are added to their accounts.</li>
              </ul>
            </div>
            <div v-if="paymentMethods.length == 0">
              <p>
                <b class="text-danger">Your organization is not currently set up with our Funding Service. Please click the button below to continue.</b>
              </p>
              <b-button @click="stripeSetup" class="btn btn-dark" >Setup Billing</b-button>
              <div id="payment-element" :style="{ 'padding': '15px' }"></div>
              <button :disabled="isLoading" class="btn btn-success" v-if="payment" @click="pay">
                  Submit Billing Details
              </button>
              <div id="error-message">
                <!-- Display error message to your customers here -->
              </div>
            </div><hr>
            <!-- Display Dashboard if client is setup with stripe -->
            <div v-if="stripeCustomerId">
              <dashboard />
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Modal from "@/components/Modal.vue";
import Dashboard from "./components/Dashboard.vue";
import { mapState } from "vuex";
import { CreateNewCustomerWithPaymentIntent, GetPaymentMethods } from "@/api/funding";

export default {
  name: "FundingDashboard",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
    Dashboard,
  },
  data() {
    return {
      publishKeyStripe: process.env.STRIPE_KEY,
      elementsOptions: {
        clientSecret: "",
      },
      confirmParams: {
        return_url: window.location.origin + "/funding-result", // success url
      },
      payment: null,
      isLoading: false,
      activeMenuItem: "fundingDashboard",
      activeMenu: "funding",
      paymentMethods: [],
    };
  },
  computed: {
    ...mapState({
      companyName: (state) => state.company.name,
      stripeCustomerId: (state) => state.company.stripeCustomerId,
      userClients: (state) => state.user.userClients,
      userEmail: (state) => state.user.email,
    }),

    stripeElements() {
      return this.$stripe.elements(this.elementsOptions);
    },
  },
  watch: {
    elementsOptions: {
      handler(newElementOptions, old) {
        console.log("in watch");
        this.stripeElements.update(newElementOptions);

        // Create and mount the Payment Element
        this.payment = this.stripeElements.create("payment");

        console.log(this.payment);
      },
      deep: true,
    },
    payment(newPayment, old) {
      newPayment.mount("#payment-element");
    },
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "fundingDashboard",
        activeMenu: this.activeMenu ? this.activeMenu : "funding",
      });
    },
    pay: async function () {
      console.log("here");
      this.isLoading = true;

      try {
        await this.stripeElements.submit();
        console.log(this.$stripe.elements());
        const { error } = await this.$stripe.confirmSetup({
          elements: this.stripeElements,
          clientSecret: this.elementsOptions.clientSecret,
          confirmParams: this.confirmParams,
        });

        if (error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          const messageContainer = document.querySelector("#error-message");
          messageContainer.textContent = error.message;
        }
      } catch (e) {
        console.error(e);
        const messageContainer = document.querySelector("#error-message");
        messageContainer.textContent = error.message;
      } finally {
        this.isLoading = false;
      }
    },
    stripeSetup: async function () {
      console.log("here");
       try {
      const payload = {
        clientID: parseInt(this.userClients.client),
        name: this.companyName,
        email: this.userEmail,
        description: "testing from frontend",
      };
     
        const resp = await CreateNewCustomerWithPaymentIntent(payload);
        this.elementsOptions = {
          ...this.elementsOptions,
          clientSecret: resp.client_secret,
        };
        console.log(resp);
      } catch (e) {
        console.error(e);
      }
    },
  },
  async created() {
    this.setActiveMenuItem();
    await this.$store.dispatch("company/fetchCompany"); // TODO all of these things should be persistent
    await this.$store.dispatch("user/fetchProfile");
    try {
      const resp = await GetPaymentMethods(this.userClients.client);

      if (resp.status != 200) {
        this.errorMessage = resp.statusText;
        return;
      }
      this.paymentMethods = resp.data.payment_methods;
    } catch (e) {
      this.errorMessage = e;
    }
  },
};
</script>

<style lang="scss" scoped>
.marginForHeader {
  margin-top: 50px;
}
</style>
